import { createAction, props } from '@ngrx/store'

import { EAggregationAnalysisType, IAggregationAnalysisQuarter, IAggregationAnalysisSector } from '~/core/models'

import { aggregationAnalysisFeatureKey } from './aggregation-analysis.state'

// quarter
export const getAggregationAnalysisQuarterData = createAction(
  `[${aggregationAnalysisFeatureKey}] Get AggregationAnalysis Quarter Data`
)

export const setAggregationAnalysisQuarterSuccess = createAction(
  `[${aggregationAnalysisFeatureKey}] Set AggregationAnalysis Quarter Success`,
  props<{
    data: IAggregationAnalysisQuarter[]
    aggType: EAggregationAnalysisType
  }>()
)

export const setAggregationAnalysisQuarterError = createAction(
  `[${aggregationAnalysisFeatureKey}] Set AggregationAnalysis Quarter Error`,
  props<{
    error: Error
  }>()
)

export const setAggregationAnalysisQuarterSelected = createAction(
  `[${aggregationAnalysisFeatureKey}] Set AggregationAnalysis Quarter Selected`,
  props<{
    selected?: IAggregationAnalysisQuarter
  }>()
)

// sector
export const getAggregationAnalysisSectorData = createAction(
  `[${aggregationAnalysisFeatureKey}] Get AggregationAnalysis Sector Data`
)

export const setAggregationAnalysisSectorSuccess = createAction(
  `[${aggregationAnalysisFeatureKey}] Set AggregationAnalysis Sector Success`,
  props<{
    data: IAggregationAnalysisSector[]
    aggType: EAggregationAnalysisType
    quarter?: IAggregationAnalysisQuarter
  }>()
)

export const setAggregationAnalysisSectorError = createAction(
  `[${aggregationAnalysisFeatureKey}] Set AggregationAnalysis Sector Error`,
  props<{
    error: Error
  }>()
)

export const setAggregationAnalysisSectorSort = createAction(
  `[${aggregationAnalysisFeatureKey}] Set AggregationAnalysis Sector Error`,
  props<{
    sortBy: string
    order: 'asc' | 'desc' | ''
  }>()
)

// aggregation type
export const setAggregationAnalysisType = createAction(
  `[${aggregationAnalysisFeatureKey}] Set Aggregation Type`,
  props<{
    aggType: EAggregationAnalysisType
  }>()
)
